/* eslint-disable no-unused-vars */
import {apolloClient} from '@/setup/apollo-setup';
import {getField, updateField} from 'vuex-map-fields';
import {FORGOT_PASSWORD, LOGIN, REGISTER, RESET_PASSWORD, SIGN_OUT} from '@/queries/modules/user';
import {serverResponseStatusSet, error} from '@/utils/notification';
import axios from 'axios';

import {GET_CURRENT_USER, GET_USER_PUBLIC_PROFILE, RESET_PASSWORD_CURRENT_USER} from "@/queries/modules/user";

const state = {
  token: localStorage.getItem('token') != null ? localStorage.getItem('token') : null,
  loginError: null,
  loginStatus: null,
  error: null,
  processing: false,
  forgotMailSuccess: null,
  resetPasswordSuccess: null,
  currentLearningCourse: null,
  currentUser: null,
  success: null,
  profile: null,
}

export default {
  namespaced: true,
  state,
  getters: {
    getField,
  },
  mutations: {
    updateField,
    setCurrentUser(state, payload) {
      state.currentUser = payload;
      state.processing = false;
      state.loginError = null;
      state.error = null;
    },
    setToken(state, payload) {
      state.token = payload;
      state.processing = false;
      state.loginError = null;
      state.error = null;
    },
    setLogout(state) {
      state.currentUser = null;
      state.token = null;
      state.processing = false;
      state.loginError = null;
      state.error = null;
    },
    setProcessing(state, payload) {
      state.processing = payload;
      state.loginError = null;
      state.error = null;
    },
    setLoginError(state, payload) {
      state.loginError = payload;
      state.currentUser = null;
      state.processing = false;
    },
    setLoginStatus(state, payload) {
      state.loginStatus = payload;
      state.currentUser = null;
      state.processing = false;
    },
    setError(state, payload) {
      state.error = payload;
      state.currentUser = null;
      state.processing = false;
    },
    setSuccess(state, payload) {
      state.error = null;
      state.success = payload;
      state.processing = false;
    },
    setForgotMailSuccess(state) {
      state.loginError = null;
      state.currentUser = null;
      state.token = null;
      state.processing = false;
      state.forgotMailSuccess = true;
    },
    setResetPasswordSuccess(state) {
      state.loginError = null;
      state.currentUser = null;
      state.token = null;
      state.processing = false;
      state.resetPasswordSuccess = true;
    },
    clearError(state) {
      state.loginError = null;
      state.error = null;
    },
    setCourseToLearn: (state, payload) => {
      state.currentLearningCourse = payload;
    },
    setUser: (state, payload) => {
      state.currentUser = payload;
    },
    setProfile: (state, payload) => {
      state.profile = payload;
    },
    removeUserState: (state) => {
      state.currentUser = null;
    },
    removeUserProfile: (state) => {
      state.profile = null;
    },
  },
  actions: {
    async login(context, payload) {
      const {commit} = context;

      localStorage.removeItem("token");

      commit('clearError');
      commit('setProcessing', true);
      try {
        const response = await axios({
          method: "post",
          url: process.env.VUE_APP_AUTH_SERVER + "/signin",
          data: {
            ...payload.credential
          },
          // withCredentials: true
        })

        if (response.status >= 200 && response.status < 400) {
          const {data} = response;
          if (data.changePassword) {
            //redirect to change password page
            payload.vm.$router.push({
              name: 'user-change-password',
              params: {
                username: payload.credential.username,
                changePasswordReason: response.data.changePasswordReason,
                oldPassword: payload.credential.password,
              }
            });
            return
          }

          const {xRegisValidation} = data
          if(xRegisValidation){
            if(xRegisValidation.isOutstanding){
              return {
                isOutstanding: xRegisValidation.isOutstanding,
                outstandingMonth: xRegisValidation.outstandingMonth,
                linkToXRegis: xRegisValidation.linkToXRegis
              }
            }else if(xRegisValidation.isStudentDocumentOffLimit){
              return {
                isStudentDocumentOffLimit: xRegisValidation.isStudentDocumentOffLimit,
                linkToXRegis: xRegisValidation.linkToXRegis
              }
            }
          }

          // proceed to main page
          localStorage.setItem('token', response.data.token);
          localStorage.setItem('rsc', JSON.stringify(response.data.rsc));


          commit('setLoginStatus', serverResponseStatusSet("Authentication Success", response.data));

          if (payload.vm.$router.history.current.path !== "/") {
            payload.vm.$router.push("/");
          }

          // move to backend
          // call x regis api for check student payment
          // check date range for check payment
          // will not check payment between 1 -3 of the month
          /*axios.post(
            process.env.VUE_APP_XREGIS_WEBAPP + "/admin/wems_api/_get_outstanding/" + payload.credential.username,
            {
              timeout: 2000
            }
          ).then((xRegisResponse) => {
            if (xRegisResponse.status === 200) {
              if (xRegisResponse.data
                && xRegisResponse.data.outstandingMonth
                && xRegisResponse.data.outstandingMonth.length > 0) {
                return {
                  outstandingMonth: xRegisResponse.data.outstandingMonth,
                  linkToXRegis: process.env.VUE_APP_XREGIS_WEBAPP
                }
              }
            }

            localStorage.setItem('token', response.data.token);
            localStorage.setItem('rsc', JSON.stringify(response.data.rsc));

            commit('setLoginStatus', serverResponseStatusSet("Authentication Success", response.data));

            if (payload.vm.$router.history.current.path !== "/") {
              payload.vm.$router.push("/");
            }
          }).catch((err) => {
            localStorage.setItem('token', response.data.token);
            localStorage.setItem('rsc', JSON.stringify(response.data.rsc));

            commit('setLoginStatus', serverResponseStatusSet("Authentication Success", response.data));

            if (payload.vm.$router.history.current.path !== "/") {
              payload.vm.$router.push("/");
            }
          })*/
        }
      } catch (e) {
        if (e.response) {
          context.commit('setLoginStatus', serverResponseStatusSet("Authentication Error", e.response.data));
        }
      }
    },
    forgotPassword({commit}, payload) {
      commit('clearError');
      commit('setProcessing', true);

      apolloClient
        .mutate({
          mutation: FORGOT_PASSWORD,
          variables: payload,
          context: {clientName: 'Prisma2'}
        })
        .then(() => {
          commit('clearError');
          commit('setForgotMailSuccess');
        })
        .catch((err) => {
          commit('setError', error(err.message));

          setTimeout(() => {
            commit('clearError');
          }, 3000);
        });
    },
    resetPassword({commit}, payload) {
      commit('clearError');
      commit('setProcessing', true);

      apolloClient
        .mutate({
          mutation: RESET_PASSWORD,
          variables: payload,
          context: {clientName: 'Prisma2'}
        })
        .then(() => {
          commit('clearError');
          commit('setResetPasswordSuccess');
        })
        .catch((err) => {
          commit('setError', error(err.message));

          setTimeout(() => {
            commit('clearError');
          }, 3000);
        });
    },
    async resetPasswordCurrentUser(context, payload) {
      context.commit('clearError');
      context.commit('setProcessing', true);
      try {
        const result = await apolloClient
          .mutate({
            mutation: RESET_PASSWORD_CURRENT_USER,
            variables: payload,
            context: {clientName: 'Prisma2'}
          });

        const {data, errors} = await result;

        if (errors) {
          context.commit('setError', error(errors));
          return null;
        } else {
          context.commit('setProcessing', false);

          return data.resetPasswordCurrentUser
        }
      } catch (e) {
        context.commit('setError', error(e));
        return {error: true, message: e.message};
      }

    },
    signOut(context, vm) {
      // Removed token
      localStorage.removeItem('token');
      localStorage.removeItem('rsc');

      // Remove developer data
      localStorage.removeItem('dev');

      context.commit('setCurrentUser', null);
      if (vm) {
        if (vm.$router && vm.$route.fullPath !== "/user/login") {
          vm.$router.push("/user/login");
        }
      } else if (window.location.pathname !== process.env.BASE_URL + 'user/login') {
        window.location = process.env.BASE_URL + 'user/login';
      }
    },
    register({commit}, payload) {
      commit('clearError');
      commit('setProcessing', true);

      apolloClient
        .mutate({
          mutation: REGISTER,
          variables: payload,
          context: {clientName: 'Prisma2'}
        })
        .then(({data}) => {
          localStorage.setItem('user', JSON.stringify(data.register.user));
          localStorage.setItem('token', data.register.token);

          commit('setToken', data.register.token);
          commit('setCurrentUser', data.register.user);
        })
        .catch((err) => {
          localStorage.removeItem('user');
          localStorage.removeItem('token');

          commit('setError', error(err.message));

          setTimeout(() => {
            commit('clearError');
          }, 3000);
        });
    },
    async initUser(context) {
      const token = localStorage.getItem("token");
      try {
        if (token
          && (!context.rootState.currentUser || !context.rootState.profile)
        ) {
          context.commit('setProcessing', true);
          try {
            const result = await apolloClient
              .query({
                query: GET_CURRENT_USER,
                fetchPolicy: "network-only",
                context: {clientName: 'Prisma2'}
              })
            const {data} = result;
            if (data && data.getCurrentUser) {
              let profile, meta;
              if (typeof data.getCurrentUser.profile === "string") {
                profile = JSON.parse(data.getCurrentUser.profile);
              }
              if (typeof data.getCurrentUser.meta === "string") {
                meta = JSON.parse(data.getCurrentUser.meta);
              }
              context.commit("setUser", {
                ...data.getCurrentUser,
                profile,
                meta
              });
              context.commit("setProfile", profile);

              return {status: {success: true, error: false, message: ""}}
            }
          } catch (e) {
            context.commit('setError', error(e));
            return {status: {success: false, error: true, message: "", full: e}}
          }
        }
      } catch (error) {
        // console.log(error)
        return null
      }
    },
    selectCourseToLearn(context, payload) {
      context.commit("setCourseToLearn", payload);
    },
    async getCurrentUser(context) {
      context.commit('setProcessing', true);
      try {
        const result = await apolloClient
          .query({
            query: GET_CURRENT_USER,
            fetchPolicy: 'network-only',
            context: {clientName: 'Prisma2'}
          });

        const {data} = result;

        // if (errors) {
        // context.commit('setError', error(errors));
        // return null;
        // } else {
        context.commit('setCurrentUser', data.getCurrentUser);
        this._vm.$currentUser = Object.assign(this._vm.$currentUser, this.state.User.currentUser);
        this._vm.$currentUser.active = true;


        return data.getCurrentUser
        // }

      } catch (e) {
        context.commit('setError', error(e));
        return null;
      }
    },
    async getPublicProfile(context, payload) {
      context.commit('setProcessing', true);
      try {
        const variables = payload;

        const result = await apolloClient
          .query({
            query: GET_USER_PUBLIC_PROFILE,
            variables,
            fetchPolicy: 'network-only',
            context: {clientName: 'Prisma2'}
          });

        const {data} = await result;
        return data.getUserPublicProfile;

      } catch (e) {
        context.commit('setError', error(e));
        return null;
      }
    },
    async currentUser(context) {
      context.commit('setProcessing', true);
      try {
        const result = await apolloClient
          .query({
            query: GET_CURRENT_USER,
            fetchPolicy: 'network-only',
            context: {clientName: 'Prisma2'}
          });

        const {data} = result;
        return data.getCurrentUser
        // }

      } catch (e) {
        context.commit('setError', error(e));
        return null;
      }
    },
  }
}
